import styled from 'styled-components';
import { Button } from '@shared/ui/Button';

const Box = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};
  font-size: 13px;
  color: ${({ theme }) => theme.colors.status.warning};
`;

/**
 * Статус проверки не прочитался (ошибка сети или сервера): на экране —
 * последний известный статус, он может быть устаревшим. Кнопка перечитывает
 * его сразу, не дожидаясь возврата на вкладку («Аудит 41», Z41-01).
 */
export function StatusReadError({ onRetry, retrying }: { onRetry: () => void; retrying: boolean }) {
  return (
    <Box role="alert">
      <span>Не удалось обновить статус проверки — показан последний известный.</span>
      <Button type="button" $variant="secondary" $size="sm" onClick={onRetry} disabled={retrying}>
        {retrying ? 'Обновляю…' : 'Повторить'}
      </Button>
    </Box>
  );
}
